class Pricing {

    constructor() {
        $(window).ready(() => {
            return this.pricingHeights();
        });
        $(window).resize(() => {
            return this.pricingHeights();
        });
    }

    pricingHeights() {
        const $prices = $('section.pricing .price .heightfix');

        $prices.css({
            'height': '',
        });
        if ($(window).width() > 768) {
            let minH = 0;

            $prices.each((i, el) => {
                if ($(el).outerHeight() > minH) { return minH = $(el).outerHeight(); }
            });

            return $prices.css({
                'height': `${ minH }px`,
            });
        }
    }
}

export default Pricing;
